let frame = 0;

export default class InputEventHandler {

  constructor(game) {

    this.detachWindowListeners = [];
    this.detachElementListeners = [];
    this.game = game;
    this.element = document.getElementById('interactive-map-canvas-3')
    this.captureDrag();
    this.captureScroll();

    this.dragStartedAt = null;
    this.distanceMoved = 0;

  }

  destructor() {
    this.detachWindowListeners.forEach(listener => {
      window.removeEventListener(...listener);
    })
    this.detachElementListeners.forEach(listener => {
      this.element.removeEventListener(...listener);
    })
  }

  attachWindowListener(...parameters){
    window.addEventListener(...parameters)
    this.detachWindowListeners.push(parameters);
  }

  attachElementListener(...parameters){
    this.element.addEventListener(...parameters)
    this.detachElementListeners.push(parameters);
  }


  captureScroll() {

    this.attachElementListener('mousewheel', e => {

      if (this.game && this.game.layers) {

        // prevent horizontal scrolling
        if (e.wheelDeltaX !== 0) {
          e.preventDefault();
        }
        if (e.wheelDeltaY !== 0) {
          e.preventDefault();
        }
      }

    }, { passive: false});

    this.attachElementListener('wheel', e => {

      if (this.game && this.game.layers) {
        this.game.moveViewport(e.deltaX, e.deltaY);
      }


    });



  }

  captureDrag() {

    this.attachWindowListener('keydown', e => {

      if (this.game && this.game.layers) {

        this.keyIteration++;

        if (this.keyIteration % 5 === 4) {
          this.keySpeed = this.keySpeed * 2;
          if (this.keySpeed > 50) {
            this.keySpeed = 50;
          }
        }


        switch(e.keyCode) {
          case 90: // z
            if(this.game.debugEnabled()) {
              console.log("Scale", this.game.scale)
              if (this.game.scale === 2) {
                this.game.setScale(1);
                break;
              }
              this.game.setScale(2);
            }
            break;
          case 68: // d
            if(this.game.debugEnabled()) {
              this.game.switchApiMode();
            }

            break;
          default:
            break;
        }
      }

    });

    this.attachWindowListener('keyup', e => {
      if (this.game && this.game.layers) {
        this.keySpeed = 10;
        this.keyIteration = 0;
      }
    });

    this.attachElementListener('mousedown', e => {
      if (this.game && this.game.layers) {
        this.dragStartedAt = {x: e.pageX, y: e.pageY};

        this.distanceMoved = 0;
      }
    });

    this.attachElementListener('touchstart', e => {

      var touch = e.touches[0];

      let pageX = touch.pageX;
      let pageY = touch.pageY;

      this.dragStartedAt = { x : pageX, y: pageY };
      this.distanceMoved = 0;

    });

    this.attachWindowListener('resize', e => {
      if (this.game && this.game.layers) {

        this.game.resizeWindow();

      }

    });
    this.attachWindowListener('orientationchange', e => {
      if (this.game && this.game.layers) {
        this.game.resizeWindow();
      }
    });

    this.attachElementListener('mousemove', e => {

      if (this.game && this.game.layers) {

        if (this.dragStartedAt) {

          let distanceMoved = Math.sqrt(((this.dragStartedAt.x - e.pageX) ** 2) + ((this.dragStartedAt.y - e.pageY) ** 2));
          this.distanceMoved += distanceMoved;
          this.game.moveViewport(this.dragStartedAt.x - e.pageX, this.dragStartedAt.y - e.pageY);
          this.dragStartedAt =  { x : e.pageX, y : e.pageY };

          return;

        }

        let status = this.game.mouseMove(e.pageX, e.pageY);

        if (status) {
          document.getElementById('interactive-map-canvas-3').style.cursor = 'pointer';
        }
        else{
          document.getElementById('interactive-map-canvas-3').style.cursor = 'default';
        }
      }

    });

    this.attachElementListener('touchmove', e => {

      if (this.game && this.game.layers) {

        var touch = e.touches[0];

        let pageX = touch.pageX;
        let pageY = touch.pageY;

        if (this.dragStartedAt) {

          this.distanceMoved += Math.sqrt(((this.dragStartedAt.x - pageX) ** 2) + ((this.dragStartedAt.y - pageY) ** 2));
          this.game.moveViewport(this.dragStartedAt.x - pageX, this.dragStartedAt.y - pageY);
          this.dragStartedAt =  { x : pageX, y : pageY };

          return;

        }
      }

    });

    this.attachElementListener('mouseup', e => {

      if (this.game && this.game.layers) {

        this.dragStartedAt = null;

        if (this.distanceMoved < 20) {
          this.game.mouseClick(e.pageX, e.pageY);
        }
        this.distanceMoved = 0;
      }

    });

    this.attachElementListener('touchend', e => {
      if (this.game && this.game.layers) {

        this.dragStartedAt = null;

        if (this.distanceMoved < 20) {
          this.game.mouseClick(e.pageX, e.pageY);
        }
        this.distanceMoved = 0;
      }
    });

  }

}
